var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZixxarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 52.2734V17.6352L102.358 0L101.517 0.840205L118.812 18.1283V51.782L102.342 68.2111L85.212 51.0896L84.3714 51.9298L101.501 69.0513L69.0825 101.483L51.7049 84.0852L50.8624 84.9237L68.2522 102.324L51.7685 118.818H18.1376L0.842442 101.464L0.00173137 102.303L17.6441 120H52.2533L69.0843 103.162L85.9014 120H120V85.8584L103.183 69.0513L120 52.2734ZM118.812 86.3515V118.814H86.3949L69.9249 102.32L102.346 69.888L118.812 86.3515ZM17.8951 52.0243L0 34.1416L0.840711 33.3015L17.89 50.3422L50.3725 17.8861L33.2647 0.843614L34.1037 0.00346066L52.0504 17.8861L17.8951 52.0243Z",
    fill: "url(#paint0_linear_4473_11991)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.356 34.1416L34.1037 102.306H0V68.2231L68.2522 0H102.351V34.1416H102.356ZM0 34.1416L34.0986 0H0V34.1416ZM102.356 68.2231L68.2522 102.306H102.351V68.2231H102.356Z",
    fill: "url(#paint1_linear_4473_11991)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8782 97.949L30.5979 78.6438L21.4346 87.8015L19.7344 86.1023L32.367 73.479L34.0673 75.1783L34.3476 94.4835L44.2225 84.6144L45.9229 86.3137L32.5784 99.6483L30.8782 97.949Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6797 71.168L37.1708 68.6785L39.1703 70.6766L36.6793 73.1662L34.6797 71.168ZM38.278 74.7659L40.7691 72.2763L50.3674 81.8688L47.8763 84.3584L38.278 74.7659Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7967 64.0532L50.8653 64.5823L50.3358 55.519L53.5387 52.3182L54.2659 64.7799L66.7353 65.5066L63.5324 68.7076L54.4636 68.1785L54.9931 77.2418L51.7904 80.4426L51.0632 67.9809L38.5938 67.2542L41.7967 64.0532Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4527 48.4058L66.5215 48.935L65.992 39.8718L69.195 36.6708L69.9221 49.1325L82.3914 49.8595L79.1886 53.0603L70.1198 52.5311L70.6493 61.5945L67.4464 64.7955L66.7192 52.3336L54.25 51.6068L57.4527 48.4058Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1226 44.741C77.824 42.4438 79.6069 40.6655 81.3811 38.8872L85.6516 34.6193L84.1524 33.121C83.5524 32.5214 83.1072 32.9665 82.6636 33.4097L76.4368 39.6329L74.9375 38.1347L80.9874 32.0884C82.7668 30.3101 84.5461 28.5318 86.8447 30.8307L94.1427 38.1261L87.3828 44.8819C85.6034 46.6602 83.8241 48.4385 81.5255 46.1396L80.1226 44.741ZM85.7031 43.5606L90.1507 39.1157L87.1507 36.1176L82.7031 40.5624C82.2578 41.0074 81.8143 41.4507 82.4143 42.0521L84.2143 43.851C84.8126 44.4506 85.2578 44.0056 85.7014 43.564L85.7031 43.5606Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9727 28.6967C86.6742 26.3996 88.4568 24.6213 90.2311 22.843L92.7221 20.3534L94.2214 21.8517L91.5532 24.5182C91.1079 24.9632 90.6627 25.4082 91.2644 26.0078L98.7635 33.5008L96.2724 35.9903L88.9727 28.6967Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4473_11991",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41F543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4473_11991",
    x1: 51.1779,
    y1: 0,
    x2: 51.1779,
    y2: 102.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41F543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZixxarLogo);
export default __webpack_public_path__ + "static/media/zixxar-logo.0fd63731fb783209f9fb1861d57664d3.svg";
export { ForwardRef as ReactComponent };